import { render, staticRenderFns } from "./historyOpenSlide.vue?vue&type=template&id=5b0da68b&scoped=true"
import script from "./historyOpenSlide.vue?vue&type=script&lang=js"
export * from "./historyOpenSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0da68b",
  null
  
)

export default component.exports